import styled from 'styled-components';

export const TemplateEditorWrapper = styled.div`
  height: calc(100vh - 130px);
  min-height: 0;

  .editor-toolbar {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }

  .editor-panes {
    min-height: 0;
    gap: 16px;
  }

  /* An even split: flex: 1 alone is not enough, because a flex item's automatic minimum size lets
     the textareas' content push their column past half. */
  .editor-half {
    flex: 0 0 calc(50% - 8px);
    min-width: 0;
    min-height: 0;
  }

  .editor-pane {
    min-height: 0;
    background: ${({ theme }) => theme.colors.sidebarBackground};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 8px;
    overflow: hidden;
  }

  .pane-header {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.backgroundColor_05};
    min-height: 40px;
  }

  .code-input {
    border: none;
    outline: none;
    resize: none;
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 12px;
    font-family: 'SF Mono', Menlo, Consolas, monospace;
    font-size: 12px;
    line-height: 1.55;
    tab-size: 2;
    color: ${({ theme }) => theme.colors.RegularText};
    background: transparent;

    &.invalid {
      background: ${({ theme }) => theme.colors.ZenNegativeSecondary_O3};
    }
  }

  .pane-error {
    border-top: 1px solid ${({ theme }) => theme.colors.ZenNegativeSecondary};
    background: ${({ theme }) => theme.colors.ZenNegativeSecondary_O3};
    color: ${({ theme }) => theme.colors.ZenNegative};
    font-family: 'SF Mono', Menlo, Consolas, monospace;
    font-size: 11px;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 120px;
    overflow: auto;
  }

  .preview-scroll {
    flex: 1;
    min-height: 0;
    overflow: auto;
    background: ${({ theme }) => theme.colors.ZenLightGray};
  }

  /* The page is rendered at its true paper width and scaled down to fit, so the preview keeps the
     proportions Chromium will print at. The frame carries the scaled footprint so surrounding
     layout - centering, scroll height - accounts for the real size on screen. */
  .preview-frame {
    flex: none;
    overflow: hidden;
  }

  .preview-page {
    transform-origin: top left;
    background: #ffffff;
    box-shadow: 0 1px 6px ${({ theme }) => theme.colors.shadowColor};

    iframe {
      display: block;
      border: none;
      background: #ffffff;
    }
  }

  .published-warning {
    background: ${({ theme }) => theme.colors.ZenOrangeSecondary};
    color: ${({ theme }) => theme.colors.ZenOrangeText};
    border: 1px solid ${({ theme }) => theme.colors.ZenOrange};
    border-radius: 6px;
  }

  .helper-hint {
    color: ${({ theme }) => theme.colors.LighterText};
    font-size: 11px;
  }
`;
